import { render } from "./PropsMixin.vue?vue&type=template&id=2765993e"
import script from "./PropsMixin.vue?vue&type=script&lang=js"
export * from "./PropsMixin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__